var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderIconColor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7499 11.0625C18.7499 10.0141 18.7499 9.30243 18.5786 8.88895C18.3503 8.33764 17.9123 7.89962 17.361 7.67126C16.9475 7.49999 16.4233 7.49999 15.375 7.49999C14.6035 7.49999 13.8321 7.49999 13.0606 7.49999C12.9342 7.49999 12.8709 7.49999 12.81 7.49669C12.2982 7.46891 11.8111 7.26717 11.4295 6.92487C11.3841 6.88413 11.3394 6.83942 11.25 6.75C11.1605 6.66057 11.1158 6.61587 11.0704 6.57512C10.6888 6.23282 10.2018 6.03109 9.68993 6.00331C9.62901 6 9.56578 6 9.43932 6C9.24288 6 9.04643 6 8.84998 6C7.58987 6 6.95981 6 6.47852 6.24523C6.05515 6.46095 5.71095 6.80515 5.49523 7.22852C5.25 7.70981 5.25 8.33987 5.25 9.59998C5.25 11.2 5.25 12.8 5.25 14.4C5.25 15.6601 5.25 16.2901 5.49523 16.7715C5.71095 17.1948 6.05515 17.539 6.47852 17.7547C6.95981 17.9999 7.58987 17.9999 8.84998 17.9999C9.89998 17.9999 10.95 17.9999 12 17.9999",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 11.25C5.25 11.25 5.25 13.35 5.25 14.4C5.25 15.6601 5.25 16.2901 5.49523 16.7715C5.71095 17.1948 6.05515 17.539 6.47852 17.7547C6.95981 18 7.58987 18 8.84998 18C10.95 18 13.05 18 15.15 18C16.4101 18 17.0401 18 17.5214 17.7547C17.9448 17.539 18.289 17.1948 18.5047 16.7715C18.6315 16.5226 18.6927 15.3362 18.7223 14.1029C18.7499 12.9505 18.7499 11.7572 18.7499 11.25H5.25Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIconColor);
export default __webpack_public_path__ + "static/media/folderIconColor.90023e4c461fb4b6c9179f5608d0db29.svg";
export { ForwardRef as ReactComponent };